var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hv-vtour"},[_c('div',{staticClass:"vtour-content",on:{"click":_vm.clickhandle}},[_c('BaseImage',{attrs:{"data":{ img: _vm.data.vtourPoster }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }